import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { S1InputSelect, IS1InputSelectItem } from '@app/s1';
import { AssistenzaService, IRicercaOperatoreParams } from '@app/shared/services/assistenza.service';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-operatore-select',
  templateUrl: './operatore-select.component.html',
  styleUrl: './operatore-select.component.scss'
})
export class OperatoreSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'assistenze.fields.operatore';

  @Input() set idStazione(newValue: string) {
    this._idStazione = newValue;
    this.loadItems();
  }

  @Input() set dataDa(newValue: Date) {
    this._dataDa = newValue;
    this.loadItems();
  }

  @Input() set dataA(newValue: Date) {
    this._dataA = newValue;
    this.loadItems();
  }

  @ViewChild('s1InputSelect')s1InputSelect: S1InputSelect;

  _idStazione: string;
  _dataDa: Date;
  _dataA: Date;

  operatori: IS1InputSelectItem[];

  constructor(private assistenzaService: AssistenzaService, private utility: UtilityService) { }

  ngOnInit(): void { 
    this.loadItems();
  }

  loadItems() {

    // stazione e date sono filtri opzionali: senza, si ottiene l'elenco completo degli operatori
    const params: IRicercaOperatoreParams = {
      page: 1,
      pageSize: 999,
      idStazione: this._idStazione,
      dataDa: this.utility.UTCDateFromLocal(this._dataDa),
      dataA: this.utility.UTCDateFromLocal(this._dataA, true)
    }
  
    this.assistenzaService.ricercaOperatore(params).subscribe(operatori => {
  
      this.operatori = operatori?.map(operatore => { 
        return { code: operatore.idOperatore, label: operatore.nomeCompletoOperatore?.trim() }  
      }) ?? [];

      if (this.operatori?.length == 1) {
        this.control?.patchValue(this.operatori[0].code);
      } else {
        
        const previousValue = this.control.value;

        if (previousValue) {
          const stillExist = this.operatori.map(item => item.code).some(code => code == previousValue);
          if (!stillExist) {
            this.s1InputSelect.clear();
          }

        }

      }
  
    })

  }

}
